import request from '@/utils/request'

const getList = (data) => {
  const { bookName, reviewerName, page, limit, sort } = data
  let query = `page=${page + 1}&limit=${limit}&sortBy=${sort.field}&orderBy=${
    sort.type
  }`

  if (bookName) query += `&bookName=${encodeURI(bookName)}`
  if (reviewerName) query += `&reviewerName=${encodeURI(reviewerName)}`

  return request({
    url: `/api/reviews?${query}`,
    method: 'get'
  })
}

const remove = (id) => {
  return request({
    url: `/api/reviews/${id}`,
    method: 'delete'
  })
}

const download = () => {
  return request({
    url: `/api/reviews/download`,
    method: 'get',
    responseType: 'blob'
  })
}

export default {
  getList,
  remove,
  download
}
